import { ScrollArea as ShadcnScrollArea } from '@/components/ui/scroll-area'
import { cn } from '@/lib/utils'

type ScrollAreaProps = React.ComponentProps<typeof ShadcnScrollArea> & {
  /**
   * Lets the area shrink to its content and only scroll once the root's
   * `max-height` is reached, instead of requiring a fixed height.
   */
  autoHeight?: boolean
}

/**
 * ScrollArea wrapper that adds content-driven height.
 *
 * The base-ui viewport is `size-full`, so `height: 100%` against an
 * auto-height root resolves to `auto` and the area never scrolls — every
 * existing usage works around that with a fixed height. `autoHeight` releases
 * the viewport height and makes it inherit the root's computed `max-height`,
 * so any `max-h-*` on the caller works without interpolating a class.
 *
 * Opt-in: without the prop the component behaves exactly like the shadcn base.
 */
function ScrollArea({ autoHeight, className, ...props }: ScrollAreaProps) {
  return (
    <ShadcnScrollArea
      className={cn(
        autoHeight &&
          '[&>[data-slot=scroll-area-viewport]]:h-auto! [&>[data-slot=scroll-area-viewport]]:max-h-[inherit]',
        className,
      )}
      {...props}
    />
  )
}

export { ScrollArea, type ScrollAreaProps }
